export default "__VITE_ASSET__C_$E2H9h__"